import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row product-page-main p-0" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexProductPage',
  setup(__props) {

const ProductSwiper = defineAsyncComponent(() => import("@/components/theme/ecommerce/productpage/ProductSwiper.vue"))
const PageDetails = defineAsyncComponent(() => import("@/components/theme/ecommerce/productpage/PageDetails.vue"))
const FilterBlock = defineAsyncComponent(() => import("@/components/theme/ecommerce/productpage/FilterBlock.vue"))
const ProdectPageTab = defineAsyncComponent(() => import("@/components/theme/ecommerce/productpage/ProdectPageTab.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ProductSwiper)),
        _createVNode(_unref(PageDetails)),
        _createVNode(_unref(FilterBlock))
      ])
    ]),
    _createVNode(_unref(ProdectPageTab))
  ]))
}
}

})